export { default as AppFrame } from "./AppFrame";
export type { AppFrameProps, AppFrameHead } from "./AppFrame";
